module.exports = __webpack_public_path__ + "img/succeed.7ef8c140.png";